function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useRef } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { SectionHeader, WorkgroupCard } from '../../molecules';
import { CallToAction, Container, EntryAnimation } from '../../atoms';
export default function WorkgroupCardsGridSection(param) {
    var title = param.title, subtitle = param.subtitle, cards = param.cards, _param_size = param.size, size = _param_size === void 0 ? 'default' : _param_size, action = param.action, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: WorkgroupCardsGridSection.name,
        className: className
    }, !!(title || subtitle) && /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title,
        subtitle: subtitle,
        className: "text-center mb-7 md:mb-8"
    }), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('grid grid-flow-row auto-rows-max gap-6', size === 'default' && 'grid-cols-1 md:grid-cols-3', size === 'small' && 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4')
    }, cards.map(function(card, cardIndex) {
        var _card_size;
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(card.action.href, "-").concat(card.title),
            delay: cardIndex % 3 / 10
        }, /*#__PURE__*/ React.createElement(WorkgroupCard, _object_spread_props(_object_spread({}, card), {
            size: (_card_size = card.size) !== null && _card_size !== void 0 ? _card_size : size
        })));
    })), !!action && /*#__PURE__*/ React.createElement("div", {
        className: "flex mt-6 justify-center"
    }, /*#__PURE__*/ React.createElement(CallToAction, action)));
}

//# sourceMappingURL=WorkgroupCardsGridSection.js.map